<template>
  <div>
    <line-chart  v-if="!printing || !chartImage" :id="chartId" ref="filteredChart" class="grad-chart mt-4 mb-4" :chart-data="chartData" :chart-labels="labels" :color1="color1" :color2="color2" :drawYGrids="drawYGrids" :width="1200" :height="350"></line-chart>
    <img v-if="printing && chartImage" :src="chartImage" class="mt-4 mb-4" style="height:200px;"/>
  </div>
</template>

<script>
// import moment from 'moment'
import LineChart from '@/components/LineChart.js'
import PersianDate from 'persian-date'
export default {
  components: {
    LineChart
  },
  data: () => ({
    chartImage: null,
    gradient: null,
    labels: []
  }),
  props: ['chartData', 'chartLabels', 'color1', 'color2', 'drawYGrids', 'printing', 'chartId'],
  computed: {
  },
  methods: {
    getColor (ratio) {
      var r = Math.ceil(parseInt(this.color1.substring(1, 2), 16) * ratio + parseInt(this.color2.substring(1, 2), 16) * (1 - ratio))
      var g = Math.ceil(parseInt(this.color1.substring(3, 4), 16) * ratio + parseInt(this.color2.substring(3, 4), 16) * (1 - ratio))
      var b = Math.ceil(parseInt(this.color1.substring(5, 6), 16) * ratio + parseInt(this.color2.substring(5, 6), 16) * (1 - ratio))
      return '#' + this.hex(r) + this.hex(g) + this.hex(b)
    },
    hex (x) {
      x = x.toString(16)
      return (x.length === 1) ? '0' + x : x
    },
    getChartElement () {
      return document.getElementById('line-chart')
    },
    calculateLabels () {
      if (!this.chartLabels) {
        return
      }
      this.labels = []
      this.chartLabels.forEach(element => {
        if (element.length === 0) {
          this.labels.push('')
          return
        }
        // eslint-disable-next-line new-cap
        this.labels.push(new PersianDate.unix(element).toLocale('fa').format('D MMMM HH:mm'))
      })
    },
    export2image: function () {
      return this.$refs.filteredChart.export2image()
    }
  },
  mounted () {
    this.calculateLabels()
  },
  watch: {
    chartData () {
    },
    chartLabels () {
      this.calculateLabels()
    },
    printing (to, from) {
      if (to) {
        this.chartImage = this.export2image()
      } else {
        this.chartImage = null
      }
    }
  }
}
</script>

<style>
.chart-title {
  font-size: large;
  color: cadetblue;
}

.grad-chart {
  height: 200px;
  position: relative;
  margin: 0 auto;
}

.grad-chart canvas {
  margin: 0 auto !important;
  height: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/GradientChart.vue